import { userManager } from '@/Core/Managers'

import type { ActivityFormContextLike } from '../Contracts/Activity.types'

const isBlank = (value: unknown): boolean => value === undefined || value === null || value === ''

/**
 * Поточний користувач — значенням «Відповідального». Select ядра впізнає
 * вибране за `@id`, а бек приймає зв'язок за IRI, тож без `@id` будуємо його з
 * `uuid` — так само, як його будує колекція співробітників.
 */
const currentUserRef = (): Record<string, unknown> | null => {
    const user = (userManager.user ?? {}) as Record<string, unknown>
    const uuid = typeof user['uuid'] === 'string' ? user['uuid'] : null

    if (!uuid) return null

    return { ...user, '@id': typeof user['@id'] === 'string' ? user['@id'] : `/services/users/${uuid}`, uuid }
}

/**
 * Значення форми нової справи (`SPEC-011` §8.4, К-13, П21): відповідальний —
 * той, хто створює (легасі `ActivityCrud.jsx:19`).
 *
 * Пише лише в порожнє поле й через `setInitialValue`: вибране людиною не
 * перезаписується, а значення за замовчуванням не рахується незбереженою
 * зміною.
 */
export const ApplyActivityCreateDefaultsTask = (formContext: ActivityFormContextLike): void => {
    if (!isBlank(formContext.values?.responsible)) return

    const user = currentUserRef()

    if (user) formContext.setInitialValue?.('responsible', user)
}
